<template>
    <div id="homeSlider" class="mt-3" >
        <div class="container">
            <div>
                <b-carousel 
                            style="text-shadow: 1px 1px 2px #333;"
                            indicators
                            controls
                            background="#fff"
                            :interval="5000"
                            img-width="1024"
                            img-height="480"
                >

                    <!-- Text slides with image -->
                    <b-carousel-slide class="carousel-img" v-for="(slide, key) in slides" :img-src="slide.img.src" :img-alt="slide.img.alt" :key="key" v-if="slide.img.src">
                        <a :href="slide.href" v-if="slide.href.length>0 && slide.text.length>0" v-html="$options.filters.decoder(slide.text)" class="p-2 titleBlockBottom slide-button" target="_blank"></a>
                    </b-carousel-slide>
                
                </b-carousel>
                
            </div>
        </div>
    </div>
</template>



<script> 

    export default {
        name:'Carousel',
        props:{
            slides : {
                type: Array
            }
        },
        data(){
            return {
                
            }
        },
        filters:{
            decoder : function(value){
                if (!value) return ''
                return window.atob(value);
            }
        }
    }
</script>

<style>
    .carousel-control-next-icon {
        background-image: url('../../assets/images/pijl-rechts.png');
        height: 36px;
    }

    .carousel-control-prev-icon {
        background-image: url('../../assets/images/pijl-links.png');
        height: 36px;
    }

    #homeSlider .carousel-caption{
        bottom: 20px;
        top: initial;
    }
</style>





// WEBPACK FOOTER //
// src/components/overall_layouts/carousel.vue